import React, { PropsWithChildren } from 'react';
import styles from './badge-premium.module.scss';
import badgeHeart from '@/assets/images/subscription/badge-heart.png';
import { Typography } from '@/ui-kit';
import clsx from 'clsx';
import i18n from '@/i18n';

interface Props {
    icon?: string;
    title?: string;
    description?: string;
    type?: 'row' | 'column';
    className?: string;
}

export const BadgePremium: React.FC<PropsWithChildren<Props>> = ({
    icon = badgeHeart,
    title = i18n.t('view_likes'),
    description,
    type = 'row',
    children,
    className,
}) => {
    return (
        <div className={clsx(styles.wrapper, styles[type], className)}>
            <div className={styles.dekor}>
                <img src={icon} alt="badgeHeart" />
            </div>
            <div className={styles.info}>
                {title && (
                    <Typography
                        className={styles.title}
                        fontFamily="SFProText"
                        fontWeight="semibold"
                        center={type === 'column'}>
                        {title}
                    </Typography>
                )}
                {description && (
                    <Typography
                        fontFamily="SFProText"
                        className={styles.description}
                        center={type === 'column'}>
                        {description}
                    </Typography>
                )}
                {children}
            </div>
        </div>
    );
};
